import { ThreatEvaluationRequestEntity, ThreatEvaluationRequestProduct, ThreatEvaluationResponseEntity, ThreatEvaluationResponseProduct } from 'interfaces/AIEvalInterfaces';
import axios from 'axios';
import KeycloakService from 'services/KeycloakService';


const runAIEvaluationEntites = async(
  request: ThreatEvaluationRequestEntity,
): Promise<ThreatEvaluationResponseEntity | null> => {
  const URL = `${process.env.REACT_APP_PYAPI_URL}/evaluate_threat`;
  return axios
    .post(URL, request, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${KeycloakService.getToken()}`
      },
      timeout: 60000,
    })
    .then((res) => {
      const { data } = res as { data: ThreatEvaluationResponseEntity };
      return data;
    })
    .catch((error) => {
      console.error(`[AI] Error evaluating threat level: ${error.message}`);
      const data = {
        entity_name: 'Error evaluating threat level',
        best_match: '',
        risk: '',
        match_probability: 0,
        explanation: `${error.message}: You may need to apply BITE Lenses or provide more detail in your search value. If the issue persist please reach out to the BITE team for assistance`,
      };
      return data;
    });
};

export const runAIEvaluationSingleEntity = async(
  name: string,
  country: string,
  address: string,
  hits: string,
): Promise<ThreatEvaluationResponseEntity | null> => {
  const request: ThreatEvaluationRequestEntity = {
    entity_name: name,
    country: country,
    address: address,
    possible_matches_json: hits,
  };
  return runAIEvaluationEntites(request);
};

const runAIEvaluationProducts = async(
  request: ThreatEvaluationRequestProduct,
): Promise<ThreatEvaluationResponseProduct | null> => {
  const URL = `${process.env.REACT_APP_PYAPI_URL}/evaluate_commodity_threat`;
  return axios
    .post(URL, request, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${KeycloakService.getToken()}`
      },
      timeout: 180000,
    })
    .then((res) => {
      const { data } = res as { data: ThreatEvaluationResponseProduct };
      return data;
    })
    .catch((error) => {
      console.error(`[AI] Error evaluating threat level: ${error.message}`);
      const data = {
        hs_code: 'Error evaluating threat level',
        risk_level: '',
        trade_category: '',
        explanation: `${error.message}: You may need to apply BITE Lenses or provide more detail in your search value. If the issue persist please reach out to the BITE team for assistance`,
      };
      return data;
    });
};

export const runAIEvaluationSingleProduct = async(
  code: string,
  origin: string,
  destination: string,
  hits: string,
): Promise<ThreatEvaluationResponseProduct | null> => {
  const request: ThreatEvaluationRequestProduct = {
    hs_code: code,
    origin_country: origin,
    destination_country: destination,
    possible_matches_json: hits,
  };
  return runAIEvaluationProducts(request);
};
